﻿import {
  appendQueryParameters,
  fetchBaseQueryWrapper,
  NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

const TAG_TYPES = {
  permissions: "Permissions",
};

export const permissionsApi = createApi({
  reducerPath: "permissions",
  baseQuery: fetchBaseQueryWrapper({ path: "permissions" }),
  tagTypes: [TAG_TYPES.permissions],
  endpoints: (builder) => ({
    getPermission: builder.query({
      query: (id) => id,
      transformResponse: (response) => response.data,
      keepUnusedDataFor: NO_CACHING,
    }),
    getPermissionsAssignmentCount: builder.query({
      query: (id) => `${id}/count`,
      transformResponse: (response) => response.data.UserCount,
    }),
    getPermissions: builder.query({
      transformResponse: (response) => response.data,
    }),
    getPermissionUsers: builder.query({
      query: (permissionId) => `${permissionId}/users?userRoleStatus=Included`,
      transformResponse: (response) => response.data,
    }),
    getPermissionUsersExcluded: builder.query({
      query: (permissionId) => `${permissionId}/users?userRoleStatus=Excluded`,
      transformResponse: (response) => response.data,
    }),
    savePermission: builder.mutation({
      query: ({ permission }) => ({
        method: "POST",
        body: permission,
      }),
      transformResponse: (response) => response,
    }),
    saveRights: builder.mutation({
      query: ({ permissionId, rights }) => ({
        url: `/${permissionId}/rights`,
        method: "POST",
        body: { rights },
      }),
      transformResponse: (response) => response.data,
    }),
    saveAssignments: builder.mutation({
      query: ({ permissionId, adGroupIds, userAssignments }) => ({
        url: `/${permissionId}/assignments`,
        method: "POST",
        body: { adGroupIds, userAssignments },
      }),
      transformResponse: (response) => response.data,
    }),
    searchPermissions: builder.query({
      query: (queryString) => appendQueryParameters("search", queryString),
      transformResponse: (response) => response.data,
      providesTags: [TAG_TYPES.permissions],
      keepUnusedDataFor: NO_CACHING,
    }),
    deletePermission: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [TAG_TYPES.permissions],
    }),
    getAdGroups: builder.query({
      query: (permissionId) => ({
        url: `/${permissionId}/adGroups`,
      }),
      transformResponse: (response) => response.data,
    }),
  }),
});

export const {
  useGetPermissionQuery,
  useGetPermissionsAssignmentCountQuery,
  useGetPermissionsQuery,
  useGetPermissionUsersQuery,
  useGetPermissionUsersExcludedQuery,
  useSavePermissionMutation,
  useSaveRightsMutation,
  useSaveAssignmentsMutation,
  useSearchPermissionsQuery,
  useDeletePermissionMutation,
  useGetAdGroupsQuery,
} = permissionsApi;
